'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiMediaFastForward = function TiMediaFastForward(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm25.1 11.5c-0.6-0.5-1.3-0.8-2.1-0.8-1.7 0-3 1.3-3 3v15c0 1.6 1.3 3 3 3 0.8 0 1.6-0.4 2.1-0.9 4-3.8 9.9-9.6 9.9-9.6s-5.9-5.8-9.9-9.7z m-15 0c-0.6-0.5-1.3-0.8-2.1-0.8-1.7 0-3 1.3-3 3v15c0 1.6 1.3 3 3 3 0.8 0 1.5-0.4 2.1-0.9 4-3.8 9.9-9.6 9.9-9.6s-5.9-5.8-9.9-9.7z' })
        )
    );
};

exports.default = TiMediaFastForward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/media-fast-forward.js
// module id = 1943
// module chunks = 0